import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { DatosPersonalesForm } from './DatosPersonalesForm';
import { EmpresasForm } from './EmpresasForm';
import { DatosLaboralesForm } from './DatosLaboralesForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

export type DatosUsuariosViewProps = {
	// types...
}

const DatosUsuariosView: React.FC<DatosUsuariosViewProps> = ({ }) => {
	const { idUsuarioElsa, accion } = useParams();

	const [pasoActual, setPasoActual] = useState(0);

	const [pasosFormulario, setPasosFormulario] = useState([
		{
			"titulo": "Datos Personales",
			"completado": false,
			render: () => {
				return <DatosPersonalesForm
					idUsuarioElsa={Number.parseInt(idUsuarioElsa!.toString())}
					onComplete={(estaCompleto) => marcarFormCompletado(0, estaCompleto)}
					accion={accion!.toString()}
				/>
			}
		},
		{
			"titulo": "Empresas",
			"completado": false,
			render: () => {
				return <EmpresasForm
					idUsuarioElsa={Number.parseInt(idUsuarioElsa!.toString())}
					onComplete={(estaCompleto) => marcarFormCompletado(1, estaCompleto)}
					accion={accion!.toString()}
				/>
			}
		},
		{
			"titulo": "Datos laborales (por empresa)",
			"completado": false,
			render: () => {
				return <DatosLaboralesForm
					idUsuarioElsa={Number.parseInt(idUsuarioElsa!.toString())}
					onComplete={(estaCompleto) => marcarFormCompletado(2, estaCompleto)}
					accion={accion!.toString()}
				/>
			}
		}
	]);

	function regresar() {
		window.history.back();
	}

	const marcarFormCompletado = (index: number, estaCompleto: boolean) => {
		setPasosFormulario((prev) =>
			prev.map((paso, idx) =>
				idx === index ? { ...paso, completado: estaCompleto } : paso
			)
		);

		if (estaCompleto && index < 3) {
			setPasoActual(index + 1)
		}
	};

	return (
		<div className='flex flex-col gap-4 border shadow-xl rounded-xl p-5 bg-white w-full h-[88%]'>
			{/* title */}
			<div>
				<div className='flex flex-row items-center font-medium text-center pb-2 gap-5 cursor-pointer' onClick={regresar}>
					<div>
						<FontAwesomeIcon icon={faChevronLeft} />
					</div>
					<h1 className='text-2xl'>
						Datos Personales
					</h1>
				</div>
			</div>
			{/* Content */}
			<div className='flex flex-col justify-between gap-5 overflow-y-auto p-1 max-h-full'>
				<Tabs>
					<TabList>
					{
						pasosFormulario.map((item, index)=><Tab key={`tab-title-${index}`}>{item.titulo}</Tab>)
					}
					</TabList>
					{
						pasosFormulario.map((item, index)=>(
							<TabPanel key={`tab-panel-${index}`}  >
								<div className="pt-5">
									{item.render ? item.render() : null}
								</div>
							</TabPanel>
						))
					}
				</Tabs>
			</div>
			{/* <div className='absolute bottom-10 right-10'>
				{pasosFormulario.filter(empresa => empresa.completado).length === pasosFormulario.length && (
					<button onClick={() => regresar()} className="btn btn-sm bg-green-400">
						Finalizar registro
					</button>
				)}
			</div> */}
		</div>
	);
};

export default DatosUsuariosView;
